export enum AdViewSource {
  Favorites = 1,
  MainPage = 2,
  SearchWithText = 3,
  SearchWithoutText = 4,
  MyProducts = 5,
}

export const AD_VIEW_SOURCE_QUERY_PARAM = 'avs';

/**
 * Stashes the ad view source client-side so it can be picked up by the target
 * page without ever putting it in the URL/href.
 */
export function stashAdViewSource(source: AdViewSource): void {
  try {
    sessionStorage.setItem(AD_VIEW_SOURCE_QUERY_PARAM, String(source));
  } catch {}
}

export type AdViewSourceEvent =
  | 'from_favorites_ads'
  | 'from_main_page'
  | 'from_serch_page_with_text_query'
  | 'from_serch_page_without_text_query'
  | 'from_my_products';

/**
 * Extracts the ad view source marker from its raw string value if present.
 */
export function decodeAdViewSource(raw: string | null | undefined): AdViewSourceEvent | null {
  if (!raw) return null;

  const numericValue = Number(raw);
  if (!Number.isFinite(numericValue)) return null;

  switch (numericValue) {
    case AdViewSource.Favorites:
      return 'from_favorites_ads';
    case AdViewSource.MainPage:
      return 'from_main_page';
    case AdViewSource.SearchWithText:
      return 'from_serch_page_with_text_query';
    case AdViewSource.SearchWithoutText:
      return 'from_serch_page_without_text_query';
    case AdViewSource.MyProducts:
      return 'from_my_products';
    default:
      return null;
  }
}
